(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("customersMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomersMenu: function (parms) {
                return $ihttp.post({
                    method: 2973,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 745,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
